$(function() {
  const MCSB_VIEWPORT = window.matchMedia("(max-width:640px)");
  mCSBActivate();
  
  // リサイズ時実行
  // -----------------------------------------------------
  window.addEventListener('resize', function() {
    //メディアクエリ連動
    mCSBActivate();
  });

  // mCSB起動
  function mCSBActivate() {
    if(!$('.create_mcsb')) return;
    if(MCSB_VIEWPORT.matches) {
      $('.create_mcsb').mCustomScrollbar({
        axis: 'x'
      });
    } else {
      $('.create_mcsb').mCustomScrollbar('destroy');
    }
  }
});